import { HelpSupportCategoryOption } from './types'

const APP_SUPPORT_CATEGORIES: HelpSupportCategoryOption[] = [
  { value: 'cant-find', label: "I can't find something" },
  { value: 'not-working', label: "Something isn't working" },
  { value: 'account', label: 'Account or sign-in' },
  { value: 'other', label: 'Something else' },
]

export { APP_SUPPORT_CATEGORIES }
